import { assertUnreachable, createSingleInterpolatedTranslationKey, TranslateFunction } from '@dreryk/react-common';
import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { visitDetailsTranslationKeys } from '../../translations';

import { getVisitTextEditorMaxHTMLContentLength } from './shared/VisitFormTextEditor';
import { VisitFormController } from './visitForm.types';

export const getInvalidVisitFieldName = (
   interviewValid: boolean,
   subjectiveAssessmentValid: boolean,
   recommendationsValid: boolean
): 'interview' | 'subjectiveAssessment' | 'recommendations' => {
   if (!interviewValid) {
      return 'interview';
   }
   if (!subjectiveAssessmentValid) {
      return 'subjectiveAssessment';
   }
   if (!recommendationsValid) {
      return 'recommendations';
   }
   return assertUnreachable(undefined);
};

type ValidateTextEditorFieldsOptions = {
   controller: VisitFormController;
   translate: TranslateFunction;
};

export const validateTextEditorFields = (options: ValidateTextEditorFieldsOptions): boolean => {
   const maxHtmlContentLength = getVisitTextEditorMaxHTMLContentLength();
   const interviewValid =
      (options.controller.getValue('interview')?.getFormattedValue() ?? '').length <= maxHtmlContentLength;
   const subjectiveAssessmentValid =
      (options.controller.getValue('subjectiveAssessments')?.getFormattedValue() ?? '').length <= maxHtmlContentLength;
   const recommendationsValid =
      (options.controller.getValue('recommendations')?.getFormattedValue() ?? '').length <= maxHtmlContentLength;
   const fieldsValid = interviewValid && subjectiveAssessmentValid && recommendationsValid;
   if (!fieldsValid) {
      dispatchSnackbarNegativeEvent(
         createSingleInterpolatedTranslationKey(
            visitDetailsTranslationKeys.formattingLimitExceeded.snackbar.message,
            'fieldName',
            options.translate(
               visitDetailsTranslationKeys.formattingLimitExceeded.snackbar.fieldName[
                  getInvalidVisitFieldName(interviewValid, subjectiveAssessmentValid, recommendationsValid)
               ]
            )
         )
      );
   }
   return fieldsValid;
};
